import styled from 'styled-components';
import PropTypes from 'prop-types';
import loadingIcon from '../../../../images/extra-saldo/ico_loading.svg';
import radioErrorIcon from '../../../../images/extra-saldo/ico_radio_error.svg';
import radioOkIcon from '../../../../images/extra-saldo/ico_radio_ok.svg';

const ExtraBalanceVerifyingWrapperStyled = styled.div`
  background: #f4f4f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const ExtraBalanceVerifyingContentStyled = styled.div`
  position: relative;
  padding: 30px 50px 70px;
  background: #ffffff;
  width: 95%;
  margin: auto;
  margin-top: 50px;
  box-shadow: 0px 2px 4px rgba(56, 20, 81, 0.15);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: opacity 0.3s;
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;

const ExtraBalanceVerifyfingTitleStyled = styled.div`
  color: #381451;
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 80px;
`;

const ExtraBalanceVerifyingItemStyled = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 20px;
  text-align: left;
  color: #553e65;
  line-height: 24px;
`;

function iconSource(status) {
  if (status === 'loading') {
    return loadingIcon;
  }
  if (status === 'ok') {
    return radioOkIcon;
  }
  if (status === 'error') {
    return radioErrorIcon;
  }
  return '';
}

const ExtraBalanceVerifyingIconStyled = styled.img.attrs(props => ({
  src: iconSource(props.status),
}))`
  margin: 5px 10px 0 0;
  height: 16px;
  width: 16px;
  flex-shrink: 0;

  animation: ${props =>
    props.status === 'loading' ? 'spin 2s linear infinite' : 'none'};
`;

ExtraBalanceVerifyingIconStyled.propTypes = {
  status: PropTypes.oneOf(['loading', 'ok', 'error']).isRequired,
};

export {
  ExtraBalanceVerifyingWrapperStyled,
  ExtraBalanceVerifyingContentStyled,
  ExtraBalanceVerifyfingTitleStyled,
  ExtraBalanceVerifyingItemStyled,
  ExtraBalanceVerifyingIconStyled,
};
